import { HTTPClient, propsToDate, propsToDatePaged } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { DateHelper } from '@abaco/web-components/src/components/DateUtils';
import axios, { CancelTokenSource } from "axios";
import { Water, WaterType, WaterOut, WaterFilter, WaterEditOut } from '../models/Water';
import { UnitOfMeasure } from '../models/UnitsOfMeasure';
import { parseDeclaredArea } from './utils';
import { PriceType } from '../models/Product';

export default class WaterApi {

    private http: HTTPClient;
    private rootPath: string;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.cancelTokenSource = null;
    }


    public async getWaters(pkCuaa: number, pagingParams: PagingParams, filter: WaterFilter | null): Promise<PagedResults<Water>> {
        const filterArr = [];
        if (filter) {
            if (filter.item_name) filterArr.push(`item_name like ${filter.item_name.toUpperCase()}`);
            if (filter.item_code) filterArr.push(`item_code like ${filter.item_code.toUpperCase()}`);
        }
        // filterArr.push(`is_shared eq 0`);
        // filterArr.push(`is_used eq 0`);
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters`, {
            params: {
                offset: pagingParams.offset,
                count: pagingParams.count,
                filter: filterArr.length > 0 ? filterArr : undefined,
            }
        });
        return res.data;
    }
    public async getWatersSearch(pkCuaa: number, pagingParams: PagingParams, search: string): Promise<PagedResults<Water>> {
        const filter = [];
        if (search) {
            filter.push(`item_name like ${search}`);
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters`, {
            params: {
                filter: filter.length ? filter : undefined,
                offset: pagingParams.offset,
                count: pagingParams.count,
            }
        });
        return res.data;
    }

    public async getWatersCodeCheck(pkCuaa: number, code: string | undefined): Promise<PagedResults<Water>> {
        const filter = [];
        if (code) {
            code = code.toUpperCase();
            filter.push(`^item_code eq ${code}`);
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters`, {
            params: {
                filter: filter.length ? filter : undefined,
                offset: 0,
                count: 0,
            }
        });
        return res.data;
    }
    public async getWatersCodeCheckOnEdit(pkCuaa: number, itemId: number, code: string | undefined): Promise<PagedResults<Water>> {
        const filter = [];
        filter.push(`item_id ne ${itemId}`);
        if (code) {
            code = code.toUpperCase();
            filter.push(`^item_code eq ${code}`);
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters`, {
            params: {
                filter: filter.length ? filter : undefined,
                offset: 0,
                count: 0,
            }
        });
        return res.data;
    }

    public async getWaterTypes(paging: PagingParams): Promise<PagedResults<WaterType>> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/water_types`, {
            params: {
                offset: paging.offset,
                count: paging.count,
            }
        })

        return res.data;
    }

    public async getWater(pkCuaa: number, waterId: number): Promise<Water> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters/${waterId}`);
        return res.data;
    }
    public async editWater(pkCuaa: number, waterId: number, detailOut: WaterEditOut): Promise<Water> {
        const res = await this.http.put(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters/${waterId}`, detailOut);
        return res.data;
    }
    public async insertWater(pkCuaa: number, detailOut: WaterOut): Promise<Water> {
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters`, detailOut);
        return res.data;
    }
    public async deleteWater(pkCuaa: number, waterId: number): Promise<Water> {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters/${waterId}`);
        return res.data;
    }

    public async getPriceType(paging: PagingParams): Promise<PagedResults<PriceType>> {
        const res = await this.http.get(`${this.rootPath}/v1/ref_prices/dictionary/price_type/WATER`, {
            params: {
                offset: paging.offset,
                count: paging.count,
            }
        })
        return res.data;
    }

}
